import { ChevronLeft } from 'lucide-react';
import { cn } from '@avanta/shared/utils/cn';
import { type Step } from '../../types';

export const MobileStepper = ({
  currentStep,
  steps,
  label,
  onBack,
}: {
  currentStep: number;
  steps: Step[];
  label: string;
  onBack?: () => void;
}): React.ReactElement => {
  const totalSteps = steps.length;
  const stepIndicator = `${currentStep}/${totalSteps}`;

  return (
    <div className="relative flex flex-col gap-2 w-full am-lg:hidden">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Go back"
          className="absolute -left-3 -top-12 w-6 h-6 rounded bg-denim-400 inline-flex items-center justify-center"
        >
          <ChevronLeft className="w-6 h-6 text-white" />
        </button>
      )}
      <div className="flex items-center gap-2">
        <p className="text-xs font-medium leading-4 text-teal-600">{stepIndicator}</p>
        <p className="text-xs font-medium leading-4 text-teal-600 truncate">{label}</p>
      </div>
      <div className="flex items-center gap-1 w-full">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={cn(
              'h-1 self-stretch flex-1',
              index === 0 && 'rounded-l-full',
              index === steps.length - 1 && 'rounded-r-full',
              currentStep >= step.id ? 'bg-teal-600' : 'bg-plum-200'
            )}
          />
        ))}
      </div>
    </div>
  );
};
